import React from 'react';

import autoBind from 'react-autobind';

// import other components within the same project here

import Localization from "composer/Localization.jsx"
import LocaleDetailView from "composer/views/locale/LocaleDetailView.jsx"

import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { Tabs, Tab, Button } from '@material-ui/core';

class EditLocaleDialog extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      open: false,
      activeTab: 0,
      title: "",
    };
    autoBind(this);
  }

  changeTab(index) {
    let newIndex = this.state.activeTab;
    if (this.refs.localeDetailView) {
      if (this.refs.localeDetailView.validateInput()) {
        newIndex = index;
      }
    }
    else {
      newIndex = index;
    }
    this.setState({ activeTab: newIndex });
    this.state.activeTab = newIndex;

    if (this.refs.localeDetailView) {
      this.refs.localeDetailView.changeActiveView(newIndex);
    }
    this.props.parent.refs.localeMapState.setBoundsChanged(false);
  }

  handleTabChange = (event, index) => {
    console.log(index.toString());
    this.changeTab(index);
  }

  close() {
    this.setState({ open: false });
    this.state.open = false;
  }

  handleClose() {
    this.props.parent.refs.localeMapState.setBoundsChanged(false);
    if (this.refs.localeDetailView.state.isDirty) {
      let dialogText = {
        title: Localization.strings.UNSAVED_CHANGES,
        content: Localization.strings.UNSAVED_REMINDER,
        confirm: Localization.strings.CONTINUE_EDITING,
        cancel: Localization.strings.DISCARD_CHANGES,
      }
      this.props.root.refs.confirmDialog.show(dialogText, this.closeCancelClicked, this.closeConfirmClicked);
    }
    else {
      this.close();
    }
  }

  closeCancelClicked() {

  }

  closeConfirmClicked() {
    this.close();
  }

  handleCancel() {
    this.handleClose();
  }

  handleUpdateClicked() {
    let localeDetailViewState = this.refs.localeDetailView.state;
    if (this.refs.localeDetailView.validateInput()) {
      // update locale info first
      let requestObj = {
        table: "epack",
        where_field: "id",
        where_value: this.props.root.getCurrentLocale().id,
        row: {
          name: localeDetailViewState.localeName,
          description: localeDetailViewState.localeDesc,
          kla: localeDetailViewState.localeKLA,
          subject: localeDetailViewState.localeSubject,
          tn_file_id: localeDetailViewState.localeCoverFileID,
          color: parseInt(localeDetailViewState.localeColor, 16),
          lang: localeDetailViewState.localeLanguage,
          is_share: (localeDetailViewState.localeShareable? 1 : 0),
          is_ready: (localeDetailViewState.localePublish? 1 : 0),
          mid_lat: localeDetailViewState.localeCenter.lat,
          mid_lon: localeDetailViewState.localeCenter.lng,
          ul_lat: localeDetailViewState.localeUpperLeft.lat,
          ul_lon: localeDetailViewState.localeUpperLeft.lng,
          br_lat: localeDetailViewState.localeBottomRight.lat,
          br_lon: localeDetailViewState.localeBottomRight.lng,
          hs_reveal_code: localeDetailViewState.hsRevealCode,
          hs_reveal_code_enabled: (localeDetailViewState.hsRevealCodeEnabled? 1 : 0)
        }
      };
      // does not need to close the dialog here
      this.props.root.refs.API.request("update", requestObj, this.updateLocaleOK, this.updateLocaleFail);

      // update bbox if bbox is dirty
      if (this.props.parent.refs.localeMapState.state.boundsChanged) {
        this.refs.localeDetailView.updateMapState();
        // this.props.parent.createMapTile(localeDetailViewState.localeUpperLeft, localeDetailViewState.localeBottomRight);
      }
      this.close();
      
      this.refs.localeDetailView.setState({ isDirty: false });
    }
  }

  updateLocaleOK(res) {
    this.props.parent.refreshLocaleList();
    this.props.root.addNotification(Localization.strings.UPDATED, true);
    
    var requestObj = {epack_id: this.props.root.getCurrentLocale().id};
    this.props.root.refs.API.request("touch_epack", requestObj);
    // this.close();
  }

  updateLocaleFail(err) {
    console.log("update locale fail " + err);
    this.props.root.addNotification(Localization.strings.UPDATE_FAILED, false);
  }

  downloadMapTileComplete() {
    let epackID = this.props.root.getCurrentLocale().id;
    this.props.parent.uploadMapTile(epackID, true);
  }

  createMapTileDone() {
    let localeDetailViewState = this.refs.localeDetailView.state;
    let requestObj = {
      table: "epack",
      where_field: "id",
      where_value: this.props.root.getCurrentLocale().id,
      row: {
        mid_lat: localeDetailViewState.localeCenter.lat,
        mid_lon: localeDetailViewState.localeCenter.lng,
        ul_lat: localeDetailViewState.localeUpperLeft.lat,
        ul_lon: localeDetailViewState.localeUpperLeft.lng,
        br_lat: localeDetailViewState.localeBottomRight.lat,
        br_lon: localeDetailViewState.localeBottomRight.lng,
      }
    };
    this.props.root.refs.API.request("update", requestObj, this.updateLocaleOK, this.updateLocaleFail);
  }

  onBoundsChanged() {
    this.props.parent.refs.localeMapState.setBoundsChanged(true);
  }

  render() {
    const steps = this.props.parent.getSteps();

    return (
      <div>
        <Dialog
          open={this.state.open}
          fullWidth={true}
          maxWidth={'lg'}
          onClose={this.handleClose}
        >
          <DialogTitle>
            {Localization.strings.EDIT + " - " + this.state.title}
          </DialogTitle>

          <DialogContent>
            <Tabs
              value={this.state.activeTab}
              onChange={this.handleTabChange}
              indicatorColor="primary"
              textColor="primary"
              centered
              variant="fullWidth"
              style={{padding:'0 0 14px 0'}}
            >
              {steps.map((label, index) => {
                return (
                  <Tab key={index} label={label}/>
                );
              })}
            </Tabs>

            <LocaleDetailView root={this.props.root} parent={this} ref="localeDetailView" activeView={this.state.activeTab}/>
          </DialogContent>

          <DialogActions style={{padding:'16px 24px'}}>
            <Button
              onClick={this.handleCancel}
            >
              {Localization.strings.CANCEL}
            </Button>
            <Button
              color="primary"
              variant="contained"
              onClick={this.handleUpdateClicked}
            >
              {Localization.strings.UPDATE}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    )
  }
}

export default EditLocaleDialog;
